import debounce from "lodash.debounce";
import { Validate, useController } from "react-hook-form";
import { sandboxClient } from "services/sandbox-api/sandboxClient";
import { LabeledInput } from "@itwin/itwinui-react";
import { FormField } from "../FormField";
import styles from "./NameInput.module.css";
import { InfoLabel } from "../info-label/InfoLabel";

interface NameInputProps extends FormField {
  userName: string;
  validate?: Validate<string, any>;
}

export const NameInput = ({ name, control, userName, validate }: NameInputProps) => {

  const {
    field,
    formState,
    fieldState: { invalid, isDirty, error }
  } = useController({
    name,
    control,
    rules: {
      required: {
        value: true,
        message: "Sandbox name is required"
      },
      maxLength: {
        value: 50,
        message: "Sandbox name entered is too long"
      },
      pattern: {
        value: /^[a-zA-Z0-9_\-\.]*$/,
        message: "Only alphanumeric characters are allowed [a-zA-Z0-9_-.]"
      },
      validate: async (value: string, values: any) => {
        if (validate)
          return validate(value, values);

        if (!isDirty)
          return true;

        if (formState.defaultValues && value === formState.defaultValues.name)
          return true;

        return new Promise((resolve) => {
          debounce(async () => {
            const result = await sandboxClient.sandboxNameExists({ userName: userName, sandboxName: value });
            resolve(result === true ? "This sandbox name already exists" : undefined);
          }, 500, { leading: true })();
        });
      }
    }
  });

  return (
    <div className={styles.input} data-testid="atp-sandbox-name-field">
      <InfoLabel label="Sandbox Name" toolTip="Sandbox name which is also a part of Url for this sandbox" required />
      <LabeledInput placeholder="Enter new name..." required
        message={error?.message?.toString()}
        status={invalid ? "negative" : undefined}
        onChange={field.onChange}
        value={field.value}
        ref={field.ref}
        onBlur={field.onBlur} />
    </div>
  )
};